import types from './types';
import create from '~/misc/create';

import get from 'lodash/get';
import {promiseAction, ActionError} from '~/misc/dispatch';
import HTTPError from '~/misc/HTTPError';
import * as api from './api';
import {getUserData} from '~/modules/user/actions';

export const saveUserPageContactInfo = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.SAVE_USER_CONTACT_INFO,
  api.saveUserPageContactInfoApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
).then(() => {
  const token = getState().user.token;
  getUserData(dispatch, getState, token);
});
export const getUserAccountInfo = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.USER_ACCOUNT_INFO,
  api.getUserAccountInfoApi(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const initUserAccountInfo = (dispatch) => dispatch(create(types.USER_ACCOUNT_INFO_INIT, {}));

export const hideAsyncErrorMessage = (dispatch, val) => dispatch(create(types.USER_ACCOUNT_PAGE_ASYNG_ERROR_HIDE, val));




// WEBPACK FOOTER //
// ./src/modules/userAccountPage/actions.js